import React from 'react';
import AnimatedContainer from 'components/AnimatedContainer';
import FAQAccordion from 'components/FAQPinkAccordion';
import { faq } from '../../constants/faq';
import css from './Faq.module.scss';

function FAQ() {
  return (
    <AnimatedContainer className={css.wrapper}>
      <section className="container">
        <div className={css.faqHeader}>
          <h2 className={css.faqTitle}>How Tutor House works FAQ</h2>
        </div>
          <div className={css.faqAccordion}>
            <FAQAccordion
              faq={faq}
              hideTitle
              noPadding
              classes={{
                block: css.accordionBlock,
                title: css.accordionTitle,
                wrapper: css.accordionWrapper
              }}/>
          </div>
          <div className={css.contactBlock}>
            <p>You can speak to a member of our Customer Success Team during the week, from Mon-Fri (9:00 to 17:00). Either email <a href="mailto:info@tutorhouse.co.uk">info@tutorhouse.co.uk</a> or call us on <a href="tel:020 3950 0320">020 3950 0320</a>. We aim to respond to all queries within 24 hours.</p>
          </div>
      </section>
    </AnimatedContainer>
  );
}

export default FAQ;
